// extracted by mini-css-extract-plugin
export default {"crc":"CRC_crc__t9TMj","row":"CRC_row__D0xly"};